// pages/Profile.js

import { useEffect , useState} from "react";
import logo from "../../karuncup.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AccountHead = (props) => {
    const navigate = useNavigate();
    const { userData } = props;
  
    
  
    useEffect(() => {
      // Redirect if user is not logged in
      if (!userData) {
        navigate("/");
      }
    }, [userData, navigate]);
  


  return (
    <div dir="rtl" className="sticky top-0 right-0 flex items-center p-4">
        <ul className="flex  items-center justify-between text-white text-sm">
            <li className="flex items-center w-fit">
                
                <div><strong>تماس با دبیرخانه : 09909430460</strong></div>
            </li>
            
        </ul>
    </div>
  );
};

export default AccountHead;